<button
  tuiIconButton
  appearance="iss-icon-button"
  size="xs"
  type="button"
  [tuiHint]="tooltip"
  [tuiHintDirection]="'bottom'"
>
  <iss-icon
    class="wo-table-action__icon"
    [name]="icon"
  />
</button>
